import React from 'react';
import TextField from '@material-ui/core/TextField';
import {isEmpty, isUndefined} from 'lodash'
import Tooltip from '@material-ui/core/Tooltip';
import {  makeStyles } from '@material-ui/core/styles';
import InputMask from "react-input-mask";

const useStyles = makeStyles((theme) => ({
    Tooltip: {
      fontSize:14
    },
  }));

function Orgnr(props) {
    const classes = useStyles();
    const [value, setValue]=React.useState(props.Orgnr)
    const [value1, setValue1]=React.useState(props.Orgnr)
    const [Type, setType]=React.useState(props.Type)
    const [Label, setLabel]=React.useState(parseInt(props.Type)!==0?"Orgnr":"Personnummer")
    const onChangeHandle=(e)=>{
        setValue(e.target.value)
    }
    const onBlurHandle=(e)=>{
        if(!isUndefined(value)){
        let value2 = value.replace(/_/g, '').replace(/\s/g, '')
        console.log(value2,"value2")
        props.onChangeKund("Orgnr",value2)
        }
    }
    React.useEffect(()=>{
        if(Type !== props.Type){
            setType(props.Type)
            setLabel(parseInt(props.Type)!==0?"Orgnr":"Personnummer")
        }
        if(value1 !== props.Orgnr){
            setValue1(props.Orgnr)
            setValue(props.Orgnr)
        }
    })
    console.log(isEmpty(props.Orgnr))
    return (
        <div>
        <Tooltip classes={classes.Tooltip}
         title={`${Label} måste anges och vara lika med eller mer är 10 siffror! Om du inte vill ange ${Label} klicka på generera för att skapa unikt ID.].`} placement="top">
        <InputMask
        mask={parseInt(props.Type)===0?"999999999999":"9999999999"}
        alwaysShowMask={true}
        value={value}
        disabled={false}
        maskChar="_"
        error={isEmpty(props.Orgnr) || props.Orgnr.length<8}
        placeholder={parseInt(props.Type)!==0?"XXXXXXXXXX":"ÅÅÅÅMMDDXXXX"}
        onChange={onChangeHandle}
        onBlur={onBlurHandle}
      >
      { () => <TextField
        size="small"
        label={`${Label}:`}
        fullWidth
        variant="outlined"
      />}
      </InputMask>
           {/*<TextField
           error={isEmpty(props.Orgnr) || props.Orgnr.length<8}
           fullWidth
           defaultValue=""
           variant="outlined"
           size="small"
           name="title"
           label={`${Label}:`}
           value={value}
           onChange={onChangeHandle}
           onBlur={onBlurHandle}
           InputLabelProps={{ shrink: true }}
           /> 
      */}
           </Tooltip>
        </div>
    );
}

export default Orgnr;